import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the reportHeader state domain
 */

const selectReportHeaderDomain = (state) =>
  state.get("reportHeader", initialState)

/**
 * Other specific selectors
 */

export const makeSelectLoadingMeditions = () =>
  createSelector(selectReportHeaderDomain, (state) =>
    state.get("loadingMeditions")
  )

export const makeSelectMeditions = () =>
  createSelector(selectReportHeaderDomain, (state) => state.get("meditions"))

export const makeSelectAllMeditions = () =>
  createSelector(selectReportHeaderDomain, (state) =>
    state.get("all_meditions")
  )

export const makeSelectAmbassadorCount = () =>
  createSelector(selectReportHeaderDomain, (state) =>
    state.get("ambassador_count")
  )

export const makeSelectIsEmptyMeditions = () =>
  createSelector(selectReportHeaderDomain, (state) =>
    state.get("isEmptyMeditions")
  )

export const makeSelectOfficializeLoading = () =>
  createSelector(selectReportHeaderDomain, (state) =>
    state.get("officializeLoading")
  )

export const makeSelectOfficialize = () =>
  createSelector(selectReportHeaderDomain, (state) => state.get("officialize"))

export const makeSelectCurrentMedition = () =>
  createSelector(selectReportHeaderDomain, (state) =>
    state.get("current_medition")
  )

export const makeSelectMeditionAvailableActions = () =>
  createSelector(selectReportHeaderDomain, (state) =>
    state.get("available_actions")
  )
/**
 * Default selector used by ReportHeader
 */

const makeSelectReportHeader = () =>
  createSelector(selectReportHeaderDomain, (substate) => substate.toJS())

export default makeSelectReportHeader
export { selectReportHeaderDomain }
